export const LocaleEnum = {
  CN: 'zh_CN',
  US: 'en_US',
  JP: 'ja_JP',
  TW: 'zh_TW',
  RU: 'ru_RU',
  FR: 'fr_FR',
  SN_US: 'es_ES',
  CZ: 'cs_CZ',
  RO: 'ro_RO',
  DE: 'de_DE',
  AF: 'af_ZA',
  MI: 'mi_NZ',
  FI: 'fi_FI',
} as const
